import React from "react";
import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import * as actions from "Actions";

class SuccessPopUp extends React.Component {
  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.successOpen !== this.props.successOpen) {
      if (nextProps.successOpen) {
        this._notificationSystem.addNotification({
          message: nextProps.successMessage,
          level: "success",
          position: "bc",
          autoDismiss: nextProps.autoDismiss,
          onRemove: () => {
            nextProps.closeSuccessSnackBar();
          }
        });
      }
    }
  }
  render() {
    return <NotificationSystem ref="notificationSystem" style={false} />;
  }
}
const mapStateToProps = state => {
  const { successOpen, successMessage, autoDismiss } = state.dashboard;

  return { successOpen, successMessage, autoDismiss };
};

export default connect(mapStateToProps, actions)(SuccessPopUp);
